// extracted by mini-css-extract-plugin
export default {"container":"ima_37_7V","grid":"ima_gri_R5ljy","items":"ima_ite_2b7TV","block":"ima_blo_187zp"};